export const URLS = {
  ERROR_PAGE: '/500.htm',
};

export const AUTH_ERROR_KEYWORDS = [
  'authentication',
  'consent',
  'login',
  'unauthorized',
  'state mismatch',
  'invalid_grant',
  'access_denied',
  'interaction',
  'failed to acquire authorization code',
  'unable to exchange authorization for tokens',
  'access token not found',
  'invalid sessionid',
];

export const REALM_PATHS = {
  EXTERNAL: {
    authorize: '/oauth2/authorize',
    token: '/oauth2/token',
    revoke: '/oauth2/revoke',
  },
  INTERNAL: {
    authorize: '/as-c0/oauth2/authorize',
    token: '/as-c0/oauth2/token',
    revoke: '/as-c0/oauth2/revoke',
  },
} as const;

export const INTERNAL_REALM_ID = '/AS' as const;

export const LOG_PREFIX = '[pingam-client][debug]';

export const SDK_TIMEOUT_MS_DEFAULT = 2000 as const;
export const SDK_TIMEOUT_RETRY_INCREMENT_MS = 4000 as const;
export const SDK_TIMEOUT_RETRIES_DEFAULT = 2 as const;
